import { Component } from 'react'

import * as h from 'h'

import styles from './styles-panel.scss'

const ArrowLine = props =>
  h.h('line', {
    strokeLinecap: 'undefined',
    strokeLinejoin: 'undefined',
    strokeWidth: '1.5',
    stroke: '#fff',
    fill: 'none',
    ...props
  })

const Arrow = ({ onClick }) =>
  onClick && (
  h.z({ onClick, ...h.ca(styles.panelArrow), name: 'scroll-down button' },
    h.svg({ viewBox: '0 0 100 40' },
      h.h('g', null,
        h.h(ArrowLine, { x1: '-0.5', x2: '50', y1: '0', y2: '40' }),
        h.h(ArrowLine, { x1: '100', x2: '49', y1: '0', y2: '40' })))))

export default class Panel extends Component {
  render () {
    const { children, onArrowClick, noHeightRestriction, className, backgroundImage } = this.props

    return h.div(h.ca(styles.panel, className, { [styles.noHeightRestriction]: noHeightRestriction }),
      h.div({ ...h.ca(styles.backdrop), style: { backgroundImage } },
        h.div(h.ca(styles.haze))
      ),
      h.div(h.ca(styles.front),
        // h.div(h.ca(styles.haze)),
        h.h(Arrow, { onClick: onArrowClick }),
        children)
      )
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Landing/Panel.js